import Modal from '@components/modals/modal/modal.component'
import Button from '@components/buttons/button/button.component'
import { useLayoutEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import './modal-instagram-profile.scoped.scss'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  openModal: boolean
  onCloseModal: () => void
}

export default ({ openModal, onCloseModal }: Props) => {
  const [width, setWidth] = useState(window.innerWidth)
  const [height, setHeight] = useState(window.innerHeight)

  const { t } = useTranslation('modalVinculateSocialNetwork')

  useLayoutEffect(() => {
    const updateWidthAndHeight = () => {
      setWidth(window.innerWidth)
      setHeight(window.innerHeight)
    }

    window.addEventListener('resize', updateWidthAndHeight)

    return () => window.removeEventListener('resize', updateWidthAndHeight)
  })

  return (
    <Modal
      forceMobileNoMargin
      modalSize={'lg'}
      open={openModal}
      className="modal-social-network"
      header={
        <div>
          <h5 className="m-0">{t('createInstagraProfile')}</h5>
        </div>
      }
      footer={
        <div>
          <Button size="sm" onClick={() => onCloseModal()}>
            <span style={{ whiteSpace: 'nowrap' }}>{t('understand')}</span>
          </Button>
        </div>
      }
      onCloseChange={() => onCloseModal()}
    >
      <div className="content" style={{ height: width < 991 ? `calc(${height}px - 130px)` : 'auto' }}>
        <h1>{t('instagramProfile')}</h1>
        <div className="arrows">
          <p>{t('instagramProfileTutorial.steps.1')}</p>
          <i className="fa-solid fa-arrow-right"></i>
          <p>{t('instagramProfileTutorial.steps.2')}</p>
          <i className="fa-solid fa-arrow-right"></i>
          <p>{t('instagramProfileTutorial.steps.3')}</p>
          <i className="fa-solid fa-arrow-right"></i>
          <p>{t('instagramProfileTutorial.steps.4')}</p>
        </div>
        <p dangerouslySetInnerHTML={{ __html: t('instagramProfileTutorial.1') }}></p>
        <p dangerouslySetInnerHTML={{ __html: t('instagramProfileTutorial.2') }}></p>
        <p dangerouslySetInnerHTML={{ __html: t('instagramProfileTutorial.3') }}></p>
        <p dangerouslySetInnerHTML={{ __html: t('instagramProfileTutorial.4') }}></p>
      </div>
    </Modal>
  )
}
